import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  constructor(private http: HttpClient) {}

  createFaq(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/faq`, data);
  }

  getAllFaq(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/faq`, {
      headers: { lang: langCode },
      params: { searchTerm }
    });
  }

  deleteFaq(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/faq/${id}`
    );
  }

  deleteFaqTranslation(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/faq/deletefaqTranslation/${id}`
    );
  }

  getFaqById(id: number): Observable<any> {
    return this.http.get(`${environment.authUrl}/faq/${id}`);
  }

  updateFaq(data: any, id: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/faq/${id}`, data);
  }
}
